import { ActionTree, Store } from "vuex";
import { ProfileState } from "./types";
import { IRootState } from "../types";
import { mutationNames } from "./mutations";
import { buildAction } from "../utils";
import { Gender } from "@dcc/types/gender";

export const actionNames = {
  UPDATE_AGE: "updateAge",
  UPDATE_GENDER: "updateGender",
  UPDATE_POSTCODE: "updatePostcode",
  UPDATE_PROFILE: "updateProfile"
};

export const actions: ActionTree<ProfileState, IRootState> = {
  [actionNames.UPDATE_AGE]({ commit }, age: number) {
    commit(mutationNames.PROFILE_SETAGE, age);
  },
  [actionNames.UPDATE_GENDER]({ commit }, gender: Gender) {
    commit(mutationNames.PROFILE_SETGENDER, gender);
  },
  [actionNames.UPDATE_POSTCODE]({ commit }, postcode: string) {
    commit(mutationNames.PROFILE_SETPOSTCODE, postcode);
  },
  [actionNames.UPDATE_PROFILE]({ commit }, profile: ProfileState) {
    commit(mutationNames.PROFILE_SETAGE, profile.age);
    commit(mutationNames.PROFILE_SETGENDER, profile.gender);
    commit(mutationNames.PROFILE_SETPOSTCODE, profile.postcode);
  }
};

export const getActions = (store: Store<IRootState>) => ({
  updateAge: buildAction<number>(store, "profile", actionNames.UPDATE_AGE),
  updateGender: buildAction<Gender>(
    store,
    "profile",
    actionNames.UPDATE_GENDER
  ),
  updatePostcode: buildAction<string>(
    store,
    "profile",
    actionNames.UPDATE_POSTCODE
  ),
  updateProfile: buildAction<ProfileState>(
    store,
    "profile",
    actionNames.UPDATE_PROFILE
  )
});
